import { createSlice } from '@reduxjs/toolkit';
import initialState from './initialState';

const tradeSort = createSlice({
  name: 'tradeSort',
  initialState,
  reducers: {
    updateTradeSort(state, action) {
      return {
        ...state,
        [action.payload.tradeState]: action.payload.sortMethod
      };
    }
  }
});

export default tradeSort;
